import { FC } from 'react';
import styles from './styles.module.scss';
import { CreateMemorialSteps } from '../CreateMemorialSteps';
import { useTranslates } from 'providers/translates';

interface CreateMemorialQuiltHeaderProps {
  title?: string;
  isActiveStep: number;
  steps: {
    index: number;
    title: string;
  }[];
  isShowInspiration?: boolean;
}

export const CreateMemorialQuiltHeader: FC<CreateMemorialQuiltHeaderProps> = ({
  title,
  isActiveStep,
  steps,
  isShowInspiration = true,
}) => {
  const { translates: t } = useTranslates();

  return (
    <div className={`center ${styles.header}`} id="createQuiltHeader">
      <span className={styles.title}>{t?.quiltBuilder?.builderHeader?.introHeading ?? 'Create a Memorial Quilt Square'}</span>
      <div className={styles.header__items}>
        <CreateMemorialSteps 
          isActiveStep={isActiveStep}
          steps={steps}
        />
        {isShowInspiration && (
          <div className={styles.header__inspiration}>
            <span className={styles.header__inspirationText}>{t?.quiltBuilder?.builderHeader?.inspirationHeading ?? 'Need inspiration?'}</span>

            <button className={`button ${styles.header__inspirationButton}`}>
              <a href="/Healing-Quilt-Sample-Memorial.pdf" className='colorNavy' target="_blank">
                {t?.quiltBuilder?.builderHeader?.inspirationExampleButtonText ?? 'Example'}
              </a>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
